module.exports = __webpack_public_path__ + "img/sq1.0b81c3ae.png";